import { Directive, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

/**
 * Обратный счётчик 'countdown' основан на таймере
 * Пример использования
 * <span [countdown]="59" [interval]="1000" (value)="myVal = $event">{{ myVal }}</span>
 */
@Directive({
  selector: '[countdown]',
})
export class CountdownDirective implements OnChanges, OnDestroy {
  private _counterSource$ = new Subject<any>();
  private _subscription = Subscription.EMPTY;
  // Количество срабатываний
  @Input() countdown: number = 100;
  // Интервал в миллисекундах срабатывания, по умолчанию 1 секунда
  @Input() interval: number = 1000;
  @Output() value = new EventEmitter<number>();

  constructor() {
    this._subscription = this._counterSource$
      .pipe(
        switchMap(({ interval, count }) =>
          timer(0, interval).pipe(
            take(count),
            tap(() => this.value.emit(--count))
          )
        )
      )
      .subscribe();
  }

  ngOnChanges() {
    this._counterSource$.next({ count: this.countdown, interval: this.interval });
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
